var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInnovationFeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#4d4d4d",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.14302 14C4.39267 12.7712 3.99707 11.3588 4.00002 9.919C4.00002 5.545 7.58202 2 12 2C16.418 2 20 5.545 20 9.919C20.003 11.3588 19.6074 12.7712 18.857 14M15 19L14.87 19.647C14.73 20.354 14.659 20.707 14.5 20.987C14.255 21.4186 13.8583 21.7436 13.387 21.899C13.082 22 12.72 22 12 22C11.28 22 10.918 22 10.613 21.9C10.1416 21.7444 9.74483 21.4189 9.50002 20.987C9.34102 20.707 9.27002 20.354 9.13002 19.647L9.00002 19M7.38302 17.098C7.29102 16.822 7.24502 16.683 7.25002 16.571C7.25567 16.4552 7.29476 16.3435 7.36256 16.2494C7.43035 16.1554 7.52394 16.083 7.63202 16.041C7.73602 16 7.88202 16 8.17202 16H15.828C16.119 16 16.264 16 16.368 16.04C16.4762 16.0821 16.5699 16.1546 16.6377 16.2489C16.7055 16.3431 16.7445 16.455 16.75 16.571C16.755 16.683 16.709 16.821 16.617 17.098C16.447 17.609 16.362 17.865 16.231 18.072C15.957 18.5046 15.5275 18.8156 15.031 18.941C14.793 19 14.525 19 13.988 19H10.012C9.47502 19 9.20602 19 8.96902 18.94C8.47268 18.8149 8.0432 18.5042 7.76902 18.072C7.63802 17.865 7.55302 17.609 7.38302 17.098Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#4d4d4d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 9.75L10.5 12V16M15.75 9.75L13.5 12V16M8.25 10.5C8.44891 10.5 8.63968 10.421 8.78033 10.2803C8.92098 10.1397 9 9.94891 9 9.75C9 9.55109 8.92098 9.36032 8.78033 9.21967C8.63968 9.07902 8.44891 9 8.25 9C8.05109 9 7.86032 9.07902 7.71967 9.21967C7.57902 9.36032 7.5 9.55109 7.5 9.75C7.5 9.94891 7.57902 10.1397 7.71967 10.2803C7.86032 10.421 8.05109 10.5 8.25 10.5ZM15.75 10.5C15.5511 10.5 15.3603 10.421 15.2197 10.2803C15.079 10.1397 15 9.94891 15 9.75C15 9.55109 15.079 9.36032 15.2197 9.21967C15.3603 9.07902 15.5511 9 15.75 9C15.9489 9 16.1397 9.07902 16.2803 9.21967C16.421 9.36032 16.5 9.55109 16.5 9.75C16.5 9.94891 16.421 10.1397 16.2803 10.2803C16.1397 10.421 15.9489 10.5 15.75 10.5Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#4d4d4d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnovationFeed);
export default __webpack_public_path__ + "static/media/innovationFeed.aa50169609972bdba03374e0578ac951.svg";
export { ForwardRef as ReactComponent };